import type { FaireProductEntity } from "../../entity_types/product";

export const p_8z45vvjkc2: FaireProductEntity = {
  token: "p_8z45vvjkc2",
  type: "product",
  name: "Wiggle Stripe Knit Grid Tee - Eucalyptus",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/f836b9e171ab132d5a59efc78cee242403f83c6c42194ccd1ea135b2f9126798.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cc087cc7dbcc19f6a1f1ff575b4f4d39668bc445aa929c57698a715f87bdae49.jpeg",
    "https://cdn.faire.com/fastly/c6ea454e105b4e3d6ba5d20d6b321f5aff342ec4166087be2cdaafcf012ad232.jpeg",
    "https://cdn.faire.com/fastly/6a391a1641743fa25c0b26bb874b46dbb08e952d1cabf0db5b802b664b40875a.jpeg",
    "https://cdn.faire.com/fastly/80e47e110c94d0a803dca0a82bc1b21763dd91711c4632867766cb5c99ddcbcf.jpeg"
  ],
  priceDollars: 75.6,
  description: "The Wiggle Stripe Tee has a relaxed shape that follows the body with a more fluid feel, created through its alternating rib structure. The surface shifts slightly as it moves, giving the silhouette a soft, wavy line. Lightweight and breathable, it sits comfortably on the body and feels easy to wear in warmer conditions.\n\nRather than relying on bold graphics, the texture carries the design. Alternating ribs create a gentle “wiggle” effect, adding subtle dimension and movement across the surface. The result is a piece that feels understated but dynamic. Pairing naturally with jeans, skirts, or shorts for everyday wear.\n\n• 100% cotton\n• Relaxed fit with a subtle wavy texture\n• Lightweight and breathable with a soft, flexible feel\n• Ideal for warm weather\n• Designed for spring and summer wear\n• Pairs well with jeans, skirts, or shorts",
  tags: [],
  msrpDollars: 168,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:31.705Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
